import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
export default {
    getList: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.acquirersUri.concat('list')).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAll: (keywords, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "searchOptions": {
                    "pageIndex": page,
                    "pageSize": pageSize,
                    "keywords": keywords
                }
            }
            HTTP.post(config.apiEndpoints.acquirersUri.concat('find'), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.acquirersUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.acquirersUri, {acquirer: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.acquirersUri, {acquirer: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}